export * from './src/bookings-v2-bookings-settings-bookings-settings.universal.js';
